<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat v-if="dialog">
      <v-card-title>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        Give your meeting a descriptive name
      </v-card-subtitle>
      <v-form ref="form" v-model="valid">
        <v-card-text class="pt-0">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="checkin.name"
                label="Meeting name"
                placeholder="e.g. John 1-on-1, Team Yellow"
                outlined
                hide-details
                :rules="[$rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="checkin.description"
                label="Meeting description"
                placeholder="Describe the reason for this meeting (optional)"
                outlined
                hide-details
              >
              </v-textarea>
            </v-col>
          </v-row>
          <v-row dense class="pt-4">
            <v-col cols="auto">
              <v-btn color="performance" :loading="saving" @click="save">
                {{ !isAdd ? "Save Meeting" : "Create Meeting" }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "EditCheckInDialog",
  components: {},
  props: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    checkin: {},
    isAdd: false
  }),
  computed: {
    title() {
      return !this.isAdd ? "Edit meeting" : "Create a meeting";
    },
    ...mapGetters({
      search_users: "user/search_users",
      profile: "profile/profile"
    })
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("checkin/saveCheckIn", this.checkin)
          .then(id => {
            if (this.isAdd) {
              this.$emit("add", id);
              this.$root.$snackbarSuccess("Meeting created");
            } else {
              this.$emit("save");
              this.$root.$snackbarSuccess("Meeting saved");
            }
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving your meeting."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    showDialog(checkin) {
      this.dialog = true;
      this.checkin = Object.assign({ attendees: [] }, checkin);
      this.isAdd = !this.checkin.id;
    }
  }
};
</script>
